import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { MapSearchService } from "../../../../shared/services/map-search/map-search.service";
import { ArcGisOwnerColumn, ArcGisPropertyColumn, ArcGisSectionalTitleColumn, ArcGisZoningColumn } from "../models/arcgis-property-column.model";
import { SessionStorageService } from "../../../../shared/services/storage/session-storage.service";
import { BehaviorSubject } from "rxjs";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { PropertySearchOption } from "../models/property-heading.model";
import _ from "underscore";
import { PropertiesSearchColumnToArcGisColumnOwnerLookup, PropertiesSearchColumnToArcGisColumnPropertyLookup, PropertiesSearchColumnToArcGisColumnSectionalTitleLookup, PropertiesSearchColumnToArcGisColumnZoningLookup } from "../models/property-search-to-arcgis.model";
import { ApiLookupConstants } from "../../../../shared/constants/api-constants/api-lookup.constants";
import { PropertiesConstants } from "../../properties.constants";
import { HttpClient } from "@angular/common/http";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { Router } from "@angular/router";
import { SearchTableService } from "../../../../shared/services/table-column-mapping/search-table.service";
import GeometryUtils from "../../../../shared/utils/geometry-utils";
import { SearchContainerHeight } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { CreateApplicationRoutingConstants } from "../../../../application/create-application/create-application-routing.constants";
let PropertySearchService = class PropertySearchService extends MapSearchService {
    sessionStorageService;
    searchTableService;
    http;
    requestStatusService;
    router;
    propertyUrl;
    ownerUrl;
    zoningUrl;
    graveUrl;
    propertiesList = new BehaviorSubject(null);
    propertiesListAsObservable = this.propertiesList.asObservable();
    zoningLookupList = new BehaviorSubject(null);
    zoningLookupListAsObservable = this.zoningLookupList.asObservable();
    selectedSearchOptionLookup;
    searchOptionsMap;
    defaultSearchColumns;
    searchOptions;
    // @ts-ignore
    arcGisPropertyOutColumnList = ArcGisPropertyColumn;
    arcGisOwnerOutColumnList = ArcGisOwnerColumn;
    arcGisZoningOutColumnList = ArcGisZoningColumn;
    arcgisSectionalTitleOutColumnList = ArcGisSectionalTitleColumn;
    propertySearchTableColumnMap = new BehaviorSubject(null);
    propertySearchTableColumnMapMapObservable = this.propertySearchTableColumnMap.asObservable();
    constructor(sessionStorageService, searchTableService, http, requestStatusService, router) {
        super(sessionStorageService, searchTableService);
        this.sessionStorageService = sessionStorageService;
        this.searchTableService = searchTableService;
        this.http = http;
        this.requestStatusService = requestStatusService;
        this.router = router;
        this.mapLocationAsObservable = this.mapLocation.asObservable();
    }
    getStartApplicationRoute() {
        const route = AppRoutingConstants.createRouteToView(this.getSelectedSystemModule() + "", CreateApplicationRoutingConstants.CREATE_APPLICATION_ROUTE, CreateApplicationRoutingConstants.DETAILS_ROUTE);
        const emptySpaceRe = new RegExp(" ", "gi");
        return route.replace(emptySpaceRe, "");
    }
    // @ts-ignore
    transformFeature(feature, searchOption) {
        switch (searchOption ? searchOption : this.searchType) {
            case PropertySearchOption.PropertyOwner:
                return {
                    ownerId: feature.attributes.OBJECTID ? feature.attributes.OBJECTID : (feature.attributes.objectid ? feature.attributes.objectid : null),
                    name: feature.attributes.Name ? feature.attributes.Name : (feature.attributes.name ? feature.attributes.name : null),
                    surname: feature.attributes.Surname ? feature.attributes.Surname : (feature.attributes.surname ? feature.attributes.surname : null),
                    idNumber: feature.attributes.IDNumber ? feature.attributes.IDNumber : (feature.attributes.idnumber ? feature.attributes.idnumber : null),
                    organisation: feature.attributes.Organisation ? feature.attributes.Organisation : (feature.attributes.organisation ? feature.attributes.organisation : null),
                    organisationRegistrationNumber: feature.attributes.OrganisationRegistrationNumber ? feature.attributes.OrganisationRegistrationNumber : (feature.attributes.organisationregistrationnumber ? feature.attributes.organisationregistrationnumber : null),
                    representative: feature.attributes.Representative ? feature.attributes.Representative : (feature.attributes.representative ? feature.attributes.representative : null),
                    sgCode: feature.attributes.SgCode ? feature.attributes.SgCode : (feature.attributes.sgcode ? feature.attributes.sgcode : null),
                    id: feature.attributes.Property_OBJECTID ? feature.attributes.Property_OBJECTID : (feature.attributes.property_objectid ? feature.attributes.property_objectid : null),
                    erfNumber: feature.attributes.ErfNo ? feature.attributes.ErfNo : (feature.attributes.erfno ? feature.attributes.erfno : null),
                    address: feature.attributes.Address ? feature.attributes.Address : (feature.attributes.address ? feature.attributes.address : null),
                    farmNumber: feature.attributes.FarmNo ? feature.attributes.FarmNo : (feature.attributes.farmno ? feature.attributes.farmno : null),
                    geometry: feature.geometry ? GeometryUtils.mapGeometryToDTO(feature.geometry) : (feature.attributes.Geometry ? GeometryUtils.mapGeometryToDTO(feature.geometry) : null)
                };
            case PropertySearchOption.PropertyZoning:
                return {
                    zoningId: feature.attributes.OBJECTID ? feature.attributes.OBJECTID : (feature.attributes.objectid ? feature.attributes.objectid : null),
                    sgCode: feature.attributes.SgCode ? feature.attributes.SgCode : (feature.attributes.sgcode ? feature.attributes.sgcode : null),
                    zoning: feature.attributes.Zoning ? feature.attributes.Zoning : (feature.attributes.zoning ? feature.attributes.zoning : null),
                    erfNumber: feature.attributes.ErfNo ? feature.attributes.ErfNo : (feature.attributes.erfno ? feature.attributes.erfno : null),
                    address: feature.attributes.Address ? feature.attributes.Address : (feature.attributes.objectid ? feature.attributes.objectid : null),
                    id: feature.attributes.Property_OBJECTID,
                    geometry: feature.geometry ? GeometryUtils.mapGeometryToDTO(feature.geometry) : null
                };
            case PropertySearchOption.Property:
            default:
                return {
                    id: feature.attributes.OBJECTID ? feature.attributes.OBJECTID : (feature.attributes.objectid ? feature.attributes.objectid : null),
                    erfNumber: feature.attributes.ErfNo ? feature.attributes.ErfNo : (feature.attributes.erfno ? feature.attributes.erfno : null),
                    address: feature.attributes.Address ? feature.attributes.Address : (feature.attributes.address ? feature.attributes.address : null),
                    allotment: feature.attributes.Allotment ? feature.attributes.Allotment : (feature.attributes.allotment ? feature.attributes.allotment : null),
                    propertyDescription: feature.attributes.PropertyDescription ? feature.attributes.PropertyDescription : (feature.attributes.propertydescription ? feature.attributes.propertydescription : null),
                    sgCode: feature.attributes.SgCode ? feature.attributes.SgCode : (feature.attributes.sgcode ? feature.attributes.sgcode : null),
                    farmNumber: feature.attributes.FarmNo ? feature.attributes.FarmNo : (feature.attributes.farmno ? feature.attributes.farmno : null),
                    ptnNum: feature.attributes.PtnNum ? feature.attributes.PtnNum : (feature.attributes.ptnnum ? feature.attributes.ptnnum : null),
                    zoning: feature.attributes.ZoningCategory ? feature.attributes.ZoningCategory : (feature.attributes.zoningcategory ? feature.attributes.zoningcategory : null),
                    geometry: feature.geometry ? GeometryUtils.mapGeometryToDTO(feature.geometry) : null,
                    totalValue: feature.attributes.TotalValue ? feature.attributes.TotalValue : (feature.attributes.totalvalue ? feature.attributes.totalvalue : null),
                    buildingUse: feature.attributes.BuildingUse ? feature.attributes.BuildingUse : (feature.attributes.buildingUse ? feature.attributes.buildingUse : null),
                    erfSize: feature.attributes.ErfSize ? feature.attributes.ErfSize : (feature.attributes.erfsize ? feature.attributes.erfsize : null),
                    buildingFloorArea: feature.attributes.BuildingFloorArea ? feature.attributes.BuildingFloorArea : (feature.attributes.buildingFloorArea ? feature.attributes.buildingFloorArea : null),
                    titleDeed: feature.attributes.TitleDeed ? feature.attributes.TitleDeed : (feature.attributes.titledeed ? feature.attributes.titledeed : null),
                };
        }
    }
    clearURLList() {
        this.ownerUrl = "";
        this.zoningUrl = "";
        this.propertyUrl = "";
    }
    setURL(searchType, url) {
        switch (searchType) {
            case PropertySearchOption.PropertyOwner:
                this.ownerUrl = url;
                break;
            case PropertySearchOption.PropertyZoning:
                this.zoningUrl = url;
                break;
            case PropertySearchOption.Property:
                this.propertyUrl = url;
                break;
        }
    }
    setPropertyList(properties) {
        this.propertiesList.next(properties);
    }
    getAttributeListForSearchType(searchOption) {
        switch (searchOption ? searchOption : this.searchType) {
            case PropertySearchOption.PropertyOwner:
                return [..._.values(this.arcGisOwnerOutColumnList)];
            case PropertySearchOption.PropertyZoning:
                return [..._.values(this.arcGisZoningOutColumnList)];
            case PropertySearchOption.SectionalTitle:
                return [..._.values(this.arcgisSectionalTitleOutColumnList)];
            case PropertySearchOption.Property:
            default:
                return [..._.values(this.arcGisPropertyOutColumnList)];
        }
    }
    getLayerUrl(searchType) {
        switch (searchType) {
            case PropertySearchOption.PropertyOwner:
                return this.ownerUrl;
            case PropertySearchOption.PropertyZoning:
                return this.zoningUrl;
            case PropertySearchOption.Property:
                return this.propertyUrl;
            default:
                return this.propertyUrl;
        }
    }
    setSearchOptionLookup(searchEnum) {
        this.searchOptionsMap = new Map();
        for (const [key, value] of Object.entries(searchEnum)) {
            // @ts-ignore
            this.searchOptionsMap.set(key, value);
        }
    }
    setSelectedSearchOption(searchOption) {
        this.selectedSearchOptionLookup = this.getSearchOptionLookup(searchOption);
        // get columns related to search options type
        if (PropertiesSearchColumnToArcGisColumnZoningLookup.get(this.selectedSearchOptionLookup)
            && !PropertiesSearchColumnToArcGisColumnPropertyLookup.get(this.selectedSearchOptionLookup))
            this.searchType = PropertySearchOption.PropertyZoning;
        else if (PropertiesSearchColumnToArcGisColumnOwnerLookup.get(this.selectedSearchOptionLookup)
            && !PropertiesSearchColumnToArcGisColumnPropertyLookup.get(this.selectedSearchOptionLookup))
            this.searchType = PropertySearchOption.PropertyOwner;
        else if (PropertiesSearchColumnToArcGisColumnSectionalTitleLookup.get(this.selectedSearchOptionLookup)
            && !PropertiesSearchColumnToArcGisColumnPropertyLookup.get(this.selectedSearchOptionLookup))
            this.searchType = PropertySearchOption.SectionalTitle;
        else
            this.searchType = PropertySearchOption.Property;
    }
    setTableColumnMap(tableColumnMap) {
        this.propertySearchTableColumnMap.next(tableColumnMap);
    }
    clearTableColumnMap() {
        this.propertySearchTableColumnMap.next(new Map());
    }
    getSearchOptionLookup(selectedSearchOption) {
        const keys = [...this.searchOptionsMap.entries()]
            .filter(({ 1: v }) => v === selectedSearchOption)
            .map(([k]) => k);
        return keys.length > 0 ? keys[0].toString() : selectedSearchOption;
    }
    getPropertyZoning(moduleId) {
        // @ts-ignore
        const params = {
            $filter: `moduleId eq ${moduleId} and name eq '${PropertiesConstants.ZONING_LOOKUP}'`
        };
        return this.http.get(ApiLookupConstants.URL, { params });
    }
    async searchByZoning(zoning) {
        this.requestStatusService.showBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        this.setPropertyList([]);
        this.searchType = PropertySearchOption.PropertyZoning;
        const url = this.getLayerUrl(this.searchType);
        await this.doSearch(url, zoning, ArcGisZoningColumn.Zoning, false).then((propertiesFound) => {
            // build links for map locator and create application request
            // @ts-ignore
            this.addMapLocatorLinks(propertiesFound);
            this.requestStatusService.removeBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        });
    }
    async searchBySectionalTitle(sectionalTitle, unitNumber) {
        // async searchBySectionalTitle(sectionalTitle:string, unitNumber:string): Promise<Array<IPropertySectionalTitleSearch>>{
        this.requestStatusService.showBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        this.setPropertyList([]);
        this.searchType = PropertySearchOption.SectionalTitle;
        const url = this.getLayerUrl(this.searchType);
        await this.doSearchSectionalTitleColumn(url, sectionalTitle, ArcGisSectionalTitleColumn.SectionalTitleId, false, unitNumber, ArcGisSectionalTitleColumn.UnitNumber).then((propertiesFound) => {
            this.addMapLocatorLinksSectionalTitle(propertiesFound);
            this.requestStatusService.removeBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        });
    }
    // build links for map locator and create application request
    addMapLocatorLinks(propertiesFound) {
        propertiesFound.forEach((property) => {
            property.link = this.setMapLink(property, SearchContainerHeight.PropertiesMap);
            property.link2 = this.setCreateApplicationLink(property);
        });
        this.setPropertyList(propertiesFound);
    }
    addMapLocatorLinksSectionalTitle(propertiesFound) {
        propertiesFound.forEach(property => {
            property.link = this.setMapLink(property, SearchContainerHeight.PropertiesMap);
            property.link2 = this.setCreateApplicationLink(property);
        });
        this.setPropertyList(propertiesFound);
    }
    setMapLink(property, height) {
        return {
            text: SharedConstants.VIEW_ON_MAP_TEXT,
            address: "",
            clickAction: (link) => {
                this.changeMapLocation(String(property.id), height);
            }
        };
    }
    setCreateApplicationLink(property) {
        return {
            text: SharedConstants.CREATE_APPLICATION_TEXT,
            address: "",
            clickAction: (link) => {
                this.startApplicationSelectedProperty(property);
            }
        };
    }
    clearPropertyList() {
        this.propertiesList.next([]);
    }
    startApplicationSelectedProperty(property) {
        const url = this.getLayerUrl(PropertySearchOption.Property);
        // @ts-ignore
        this.doSearch(url, property.id.toString(), ArcGisPropertyColumn.Id, true, PropertySearchOption.Property, true, true).then((result) => {
            if (result.length > 0) {
                this.router.navigate([this.getStartApplicationRoute()], { state: { propertyData: JSON.stringify(result[0]) } });
            }
        });
    }
    static ctorParameters = () => [
        { type: SessionStorageService },
        { type: SearchTableService },
        { type: HttpClient },
        { type: RequestStatusService },
        { type: Router }
    ];
};
PropertySearchService = __decorate([
    Injectable({
        providedIn: "root"
    })
], PropertySearchService);
export { PropertySearchService };
